import React from 'react';
import './Preloader.css'; // Import CSS for styling

const Preloader = () => {
    return (
        <div className="preloader-container">
            <div className="spinner">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
            </div>
            <div className="company-name"></div>
        </div>
    );
};

export default Preloader;
